export default __webpack_public_path__ + "static/media/phone-Icon-blue.7e49ecfc.svg";